import classNames from 'classnames'
import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import { FC, ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './KpiTile.module.scss'

interface IKPITileProps {
  title: string
  value: ReactNode
  footer: ReactNode
}

export const KpiTile: FC<IKPITileProps> = ({ title, value, footer }) => {
  return (
    <P360Card className={classNames(styles.root)} bodyClassName={styles.body}>
      <div className={styles.title}>
        <Translation text={title} />
      </div>

      <div className={styles.value}>{value}</div>

      <div className={styles.footer}>{footer}</div>
    </P360Card>
  )
}
